import { render } from "./ViewCard.vue?vue&type=template&id=a403d88a"
import script from "./ViewCard.vue?vue&type=script&lang=js"
export * from "./ViewCard.vue?vue&type=script&lang=js"
script.render = render

export default script